import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { AddOrderFormValues } from "../../Interfaces/callOptionsInterfaces";

export interface OrderSliceState {
  addOrderFormValues: AddOrderFormValues | null;
  orderTableFetchDataFlag: boolean;
  tradeTableFetchDataFlag: boolean;
}

const initialState: OrderSliceState = {
  addOrderFormValues: null,
  orderTableFetchDataFlag: false,
  tradeTableFetchDataFlag: false,
};

const RBCSOrderSlice = createSlice({
  name: "rbcsOrder",
  initialState,
  reducers: {
    setRBCSAddOrderFormValues: (
      store,
      action: PayloadAction<AddOrderFormValues>
    ) => {
      if (store.addOrderFormValues !== action.payload)
        store.addOrderFormValues = action.payload;
    },
    setRBCSOrderTableFetchDataFlag: (store, action: PayloadAction<boolean>) => {
      if (store.orderTableFetchDataFlag !== action.payload)
        store.orderTableFetchDataFlag = action.payload;
    },
    setRBCSTradeTableFetchDataFlag: (store, action: PayloadAction<boolean>) => {
      if (store.tradeTableFetchDataFlag !== action.payload)
        store.tradeTableFetchDataFlag = action.payload;
    },
  },
});

export const {
  setRBCSAddOrderFormValues,
  setRBCSOrderTableFetchDataFlag,
  setRBCSTradeTableFetchDataFlag,
} = RBCSOrderSlice.actions;
export default RBCSOrderSlice.reducer;
